export const ActionTypes = {
    TEMPLATE_REQUEST : 'TEMPLATE_REQUEST',
    TEMPLATE_FAILURE : 'TEMPLATE_FAILURE',
    TEMPLATE_SUCCESS : 'TEMPLATE_SUCCESS',
    TEMPLATE_LIST : 'TEMPLATE_LIST',
}